import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "./useAuth";

export type AppRole = "admin" | "moderator" | "revisor" | "user";

export function useUserRole() {
  const { user, loading: authLoading } = useAuth();

  const query = useQuery({
    queryKey: ["user_roles", user?.id],
    enabled: !!user?.id,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", user!.id);
      if (error) throw error;
      return (data ?? []).map((r) => r.role as AppRole);
    },
    staleTime: 5 * 60 * 1000,
  });

  const roles = query.data ?? [];

  return {
    roles,
    isAdmin: roles.includes("admin"),
    isRevisor: roles.includes("revisor"),
    isAdminOrRevisor: roles.includes("admin") || roles.includes("revisor"),
    isModerator: roles.includes("moderator"),
    isLoading: authLoading || query.isLoading,
    user,
  };
}
